import React, { useEffect } from "react";
import styles from "./Cover.module.css";
import { Link } from 'react-router-dom';


export const Cover = (props) => {

    // props:
    // 
    // mediaItem - object containing book infromation
    // loc - location of cover on page, for when a book appears more than once
    // size - S, M, L, or XL
    // link - bool, should cover be clickable

    // ----------------------------------------------------- STATE AND HOOKS

    let mediaPath = `/${props.mediaItem.type}/` + props.mediaItem.mediaid;

    let token = localStorage.getItem("token");
    let imageName = getImageName();

    // const img = cld
    //     .image(imageName)
    //     .format('auto') // Optimize delivery by resizing and applying auto-format and auto-quality
    //     .quality('auto:best')

    useEffect(() => {
        // checks cache for cover
        caches.open(`earmarked-cover-cache-${new Date().toISOString().slice(0, 10)}`).then(async (cache) => {
            try {
                const response = await cache
                    .match(imageName);
                const reader = response.body.getReader();
                const stream = new ReadableStream({
                    start(controller) {
                        return pump();
                        function pump() {
                            return reader.read().then(({ done, value }) => {
                                // When no more data needs to be consumed, close the stream
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                // Enqueue the next data chunk into our target stream
                                controller.enqueue(value);
                                return pump();
                            });
                        }
                    },
                });
                const response_1 = new Response(stream);
                const blob = await response_1.blob();
                const url = URL.createObjectURL(blob);
                // renders image
                if (document.getElementById(`cover${props.mediaItem.mediaid}${props.loc}`)) { document.getElementById(`cover${props.mediaItem.mediaid}${props.loc}`).src = url; }

            } catch {
                // image not found in cache
                console.log("NO IMAGR HERE BOSS")
                getCoverFromBack()
            }
        })

    }, [props.mediaItem]);

    // ----------------------------------------------------- PRE-RENDER


    // function cleanUpCache () {
    //     // removes old caches
    //     caches.keys().then((keyList) => {
    //         keyList.map((key) => {
    //             if (key !== `earmarked-cover-cache-${new Date().toISOString().slice(0,10)}`) {
    //                 return caches.delete(key);
    //             }
    //         })
    //     })
    // }


    function getImageName() {
        // determins correct image name for media type

        let imagename = "https://res.cloudinary.com/dignlwvzp/image/upload/v1/";

        switch (props.mediaItem.type) {
            case "book":
                var isbn = props.mediaItem.isbn.replace(/\s/g, ''); // removes random space after isbn
                imagename = imagename + isbn + ".jpg"; 
                break;
            case "movie":
                imagename = imagename + "MOVIE" + props.mediaItem.mediaid + ".jpg";
                break;
            case "tvshow":
                imagename = imagename + "TV" + props.mediaItem.mediaid + ".jpg";
                break;
            case "album":
                imagename = imagename + "ALBUM" + props.mediaItem.mediaid + ".jpg";
                break;
            case "videogame":
                imagename = imagename + "VIDEOGAME" + props.mediaItem.mediaid + ".jpg";
                break;
            default:
                break;
        }
        return imagename
    }

    async function getCoverFromBack() {
        // gets cover from cloudrny

        let imageRequest = new Request(imageName)
        const response = await fetch(imageRequest);
        
        // handles not found cover
        let respIsGood = response.clone();
        if (respIsGood.status === 404) {
            console.log("failed to fetch cover")
            return false
        }

        let resp = response.clone();

        caches.open(`earmarked-cover-cache-${new Date().toISOString().slice(0, 10)}`).then((cache) => {
            cache.put(imageRequest, resp)
        });

        const reader = response.body.getReader();
        let stream = new ReadableStream({
            start(controller) {
                return pump();
                function pump() {
                    return reader.read().then(({ done, value }) => {
                        // When no more data needs to be consumed, close the stream
                        if (done) {
                            controller.close();
                            return;
                        }
                        // Enqueue the next data chunk into our target stream
                        controller.enqueue(value);
                        return pump();
                    });
                }
            },
        })

        let responseStream = new Response(stream)
        // Create a new response out of the stream
        let blob = await responseStream.blob()
                    .then((bl) => {
                        // Create an object URL for the response
                        let obj = URL.createObjectURL(bl)
                        // Update image
                        // renders image
                        if (document.getElementById(`cover${props.mediaItem.mediaid}${props.loc}`)) {
                            document.getElementById(`cover${props.mediaItem.mediaid}${props.loc}`).src = obj
                        } else {
                            console.log("Failed to find image on page")
                        }
                    })

    }


    // ----------------------------------------------------- RENDER

    if (props.link === false) {
        switch (props.size) {
            case "S":
                return (
                    <section className={styles.containerS} >
                        <img
                            className={styles.bookCoverS}
                            id={`cover${props.mediaItem.mediaid}${props.loc}`}
                            key={props.mediaItem.mediaid}
                            src={"/assets/images/blankCover.jpg"}
                            alt={`cover for ${props.mediaItem.mediaid} `}
                            style={{ margin: '10px' }}
                        />
                    </section>
                );

            case "M":
                return (
                    <section className={styles.containerM} >
                        <img
                            className={styles.bookCoverM}
                            id={`cover${props.mediaItem.mediaid}${props.loc}`}
                            key={props.mediaItem.mediaid}
                            src={"/assets/images/blankCover.jpg"}
                            alt={`cover for ${props.mediaItem.mediaid} `}
                            style={{ margin: '10px' }}
                        />
                    </section>
                );

            case "L":
                return (
                    <section className={styles.containerL} >
                        <img
                            className={styles.bookCoverL}
                            id={`cover${props.mediaItem.mediaid}${props.loc}`}
                            key={props.mediaItem.mediaid}
                            src={"/assets/images/blankCover.jpg"}
                            alt={`cover for ${props.mediaItem.mediaid} `}
                            style={{ margin: '10px' }}
                        />
                    </section>
                );

            case "XL":
                return (
                    <section className={styles.containerXL} >
                        <img
                            className={styles.bookCoverXL}
                            id={`cover${props.mediaItem.mediaid}${props.loc}`}
                            key={props.mediaItem.mediaid}
                            src={"/assets/images/blankCover.jpg"}
                            alt={`cover for ${props.mediaItem.mediaid} `}
                            style={{ margin: '10px' }}
                        />
                    </section>
                );

                            default:
                return (
                   <section className={styles.containerM} >
                            <img
                             className={styles.bookCoverM}
                                id={`cover${props.mediaItem.mediaid}${props.loc}`}
                                key={props.mediaItem.mediaid}
                                src={"/assets/images/blankCover.jpg"}
                                alt={`cover for no size link `}
                                style={{ margin: '10px' }}
                            />

                    </section>
                );
        }
    } else {
        switch (props.size) {
            case "S":
                return (
                    <section className={styles.containerS} >
                        <Link to={mediaPath} className={styles.link}>
                            <img
                                className={styles.bookCoverS}
                                id={`cover${props.mediaItem.mediaid}${props.loc}`}
                                key={props.mediaItem.mediaid}
                                src={"/assets/images/blankCover.jpg"}
                                alt={`cover for ${props.mediaItem.mediaid} `}
                                style={{ margin: '10px' }}
                            />
                        </Link>
                    </section>
                );

            case "M":
                return (
                    <section className={styles.containerM} >
                        <Link to={mediaPath} className={styles.link}>
                            <img
                             className={styles.bookCoverM}
                                id={`cover${props.mediaItem.mediaid}${props.loc}`}
                                key={props.mediaItem.mediaid}
                                src={"/assets/images/blankCover.jpg"}
                                alt={`cover for ${props.mediaItem.mediaid} `}
                                style={{ margin: '10px' }}
                            />
                        </Link>
                    </section>
                );

            case "L":
                return (
                    <section className={styles.containerL} >
                        <Link to={mediaPath} className={styles.link}>
                            <img
                             className={styles.bookCoverL}
                                id={`cover${props.mediaItem.mediaid}${props.loc}`}
                                key={props.mediaItem.mediaid}
                                src={"/assets/images/blankCover.jpg"}
                                alt={`cover for ${props.mediaItem.mediaid} `}
                                style={{ margin: '10px' }}
                            />
                        </Link>
                    </section>
                );

            case "XL":
                return (
                    <section className={styles.containerXL} >
                        <Link to={mediaPath} className={styles.link}>
                            <img
                                className={styles.bookCoverXL}
                                id={`cover${props.mediaItem.mediaid}${props.loc}`}
                                key={props.mediaItem.mediaid}
                                src={"/assets/images/blankCover.jpg"}
                                alt={`cover for ${props.mediaItem.mediaid} `}
                                style={{ margin: '10px' }}
                            />
                        </Link>
                    </section>
                );

            default:
                return (
                   <section className={styles.containerM} >
                            <img
                             className={styles.bookCoverM}
                                id={`cover${props.mediaItem.mediaid}${props.loc}`}
                                key={props.mediaItem.mediaid}
                                src={"/assets/images/blankCover.jpg"}
                                alt={`cover for no size link `}
                                style={{ margin: '10px' }}
                            />

                    </section>
                );
        }
    }

}